import classNames from 'clsx';
import React, { type FC, type ReactElement, type ReactNode } from 'react';

import styles from './SubscriptionInfoBlock.css';

interface IProps {
    title: string;
    id: string;
    size?: 'medium' | 'large';
    footer?: ReactNode;
}

export const SubscriptionInfoBlock: FC<IProps> = ({ title, id, children, footer, size = 'medium' }): ReactElement => {
    return (
        <div
            className={classNames(styles.root, {
                [styles[`root_${id}`]]: id,
                [styles[`root_size_${size}`]]: size,
            })}
        >
            <div className={styles.title}>{title}</div>
            <div className={styles.info}>{children}</div>
            {footer}
        </div>
    );
};

SubscriptionInfoBlock.displayName = 'SubscriptionInfoBlock';
